import {CardListener, NfcCard, NfcReader} from "@variocube/app-api";

export class MockNfcReader implements NfcReader {

    private cardListeners = new Set<CardListener>();

    addCardListener(listener: CardListener): void {
        this.cardListeners.add(listener);
    }

    removeCardListener(listener: CardListener): void {
        this.cardListeners.delete(listener);
    }

    presentCard(card: NfcCard) {
        this.cardListeners.forEach(cardListener => cardListener(card));
    }

    removeCard() {
        this.cardListeners.forEach(cardListener => cardListener(undefined));
    }
}